<template>
  <div class="CannotDeleteLyricPopup">
    <div v-if="!areLyricPlaylistsVisible" class="info">
      <h2 class="font-size-middle">Piosenka, którą chcesz usunąć znajduje się w
        {{ playlistItems.length }} playlistach.</h2>
      <button class="show-button  font-size-small"
              @click="showLyricPlaylists">Pokaż
      </button>
      <h2 class="font-size-middle">Usuń piosenki z playlist a następnie kontynuuj operację.</h2>
    </div>
    <div v-if="areLyricPlaylistsVisible" class="show-playlists">
      <div v-for="name in playlistNames" :key="name.key">
        {{ name }}
      </div>
    </div>
    <button class="close-button font-size-small"
            @click="$emit('cancel')">zamknij
    </button>
  </div>
</template>

<script>
import { getBandLyricsService } from '@/services/bandLyricsService'

export default {
  name: 'CannotDeleteLyricPopup',
  data () {
    return {
      areLyricPlaylistsVisible: false,
      playlistNames: [],
    }
  },
  props: {
    playlistItems: {
      required: true,
    }
  },
  async mounted () {
    let playlistId = ''
    let playlistName = ''

    for (const playlist of this.playlistItems) {
      playlistId = await getBandLyricsService().getBandLyricPlaylist(playlist)
      playlistName = await getBandLyricsService().getBandLyricPlaylistName(playlistId)
      this.playlistNames.push(playlistName)
    }
  },
  methods: {
    showLyricPlaylists () {
      this.areLyricPlaylistsVisible = true
    },
  }
}

</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.CannotDeleteLyricPopup {
  z-index: 2;
  position: fixed;
  top: 50%;
  left: 50%;
  width: 400px;
  height: 250px;
  border: 2px solid red;
  border-radius: 10px;
  margin: auto;
  padding: 20px 30px;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  background-color: rgb(0, 0, 0);
  @media only screen and (max-width: $phone-max-width) {
    height: 200px;
  }
  @media only screen and (max-width: 500px) {
    width: 300px;
    padding: 10px 20px;
  }

  h2 {
    color: $dark-text;
    font-weight: normal;
    text-align: center;
  }

  .show-button {
    min-width: 100px;
    height: 25px;
    background-color: transparent;
    color: white;
    border-color: white;
    border-radius: 6px;
    margin: 10px 120px 0 120px;
    cursor: pointer;
    @media only screen and (max-width: 500px) {
      margin-left: 80px;
      margin-right: 80px;
    }
  }

  .close-button {
    margin: 10px 120px 0 120px;
    min-width: 100px;
    height: 25px;
    background-color: transparent;
    color: white;
    border-color: $primary;
    border-radius: 6px;
    cursor: pointer;
    @media only screen and (max-width: 500px) {
      margin-left: 80px;
      margin-right: 80px;
    }
  }
}
</style>
